import { useQuery } from "@tanstack/react-query";
import {
  listUsersApiAdminUsersGetOptions,
  listUsersApiAdminUsersGetQueryKey,
} from "../generated/api/@tanstack/react-query.gen";
import { updateBillingExemptApiAdminUsersClerkUserIdBillingExemptPatch } from "../generated/api/sdk.gen";
import type { AdminUserResponse } from "../generated/api/types.gen";
import { useAdminBillingExemptList } from "./useAdminBillingExemptList";

export function useAdminUsers(debouncedQuery: string) {
  const query = useQuery({
    ...listUsersApiAdminUsersGetOptions({ query: { query: debouncedQuery } }),
    placeholderData: (previousData) => previousData,
  });

  const { items, togglingIds, ...rest } = useAdminBillingExemptList<
    AdminUserResponse,
    "users"
  >({
    listKey: "users",
    idOf: (user) => user.clerk_user_id,
    queryKey: listUsersApiAdminUsersGetQueryKey(),
    mutationFn: async ({ id, billingExempt }) => {
      const { data } =
        await updateBillingExemptApiAdminUsersClerkUserIdBillingExemptPatch({
          path: { clerk_user_id: id },
          body: { billing_exempt: billingExempt },
        });
      return data;
    },
    query,
  });

  return { users: items, togglingUsers: togglingIds, ...rest };
}
